<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'OrderItemDetail',
  props: {
    orderId: {
      type: String,
      required: true,
    },
    itemId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      orderItem: null,
      backRoute: {
        name: 'order-details',
        params: { orderId: this.orderId },
      },
    }
  },
  computed: {
    ...mapGetters('me', [
      'canUpdateOrderItems',
    ]),
    providerProductRoute() {
      const { orderItem } = this

      if (orderItem) {
        return {
          name: 'provider-product',
          params: {
            providerId: orderItem.providerId,
            providerProductId: orderItem.providerProductId,
          },
        }
      }

      return null
    },
    supplierRoute() {
      const { orderItem } = this

      if (orderItem) {
        return {
          name: 'supplier-details',
          params: {
            id: this.orderItem.supplierId,
          },
        }
      }

      return null
    },
    supplierProductRoute() {
      const { orderItem } = this

      if (orderItem) {
        return {
          name: 'supplier-product',
          params: {
            supplierId: orderItem.supplierId,
            sku: orderItem.supplierProductSku,
          },
        }
      }

      return null
    },
  },
  async created() {
    this.fetchOrderItem()
  },
  methods: {
    ...mapActions('order', ['getOrderItem']),
    async fetchOrderItem() {
      this.loading = true

      const [err, result] = await this.getOrderItem(this.itemId)

      if (err || !result) {
        this.getErrorMessage(err || { status: 404 }, 'Contract', 'ID', this.itemId)
      } else {
        this.orderItem = result
      }

      this.loading = false
    },
    showUpdTackingCodeModal() {
      this.$modal.show('update-tracking-code', {
        props: { orderItem: this.orderItem },
        on: {
          updated: this.fetchOrderItem,
        },
      })
    },
  },
}
</script>

<template>
  <main-layout
    title="Order Item Details"
    :back="backRoute"
    :loading="loading"
    :error-message="errorMessageText"
  >
    <template
      v-if="!errorMessageText && canUpdateOrderItems"
      #header
    >
      <el-button
        :disabled="loading"
        type="primary"
        @click="showUpdTackingCodeModal"
      >
        Update Tracking Code
      </el-button>
    </template>
    <data-box
      v-if="!loading && orderItem"
      header="Information"
      :status="false"
    >
      <data-list :class="$style.datalist">
        <dt>Date Created</dt>
        <dd>{{ orderItem.createdAt | dateTime }}</dd>

        <dt>ID</dt>
        <dd>{{ orderItem.id }}</dd>

        <dt>External ID</dt>
        <dd>{{ orderItem.externalId }}</dd>

        <dt>Order ID</dt>
        <dd>
          <router-link :to="backRoute">
            {{ orderId }}
          </router-link>
        </dd>

        <dt>Provider Product ID</dt>
        <dd>
          <router-link :to="providerProductRoute">
            {{ orderItem.providerProductId }}
          </router-link>
        </dd>

        <dt>Supplier ID</dt>
        <dd>
          <router-link :to="supplierRoute">
            {{ orderItem.supplierId }}
          </router-link>
        </dd>

        <dt>Supplier Product Name</dt>
        <dd>
          <router-link :to="supplierProductRoute">
            {{ orderItem.supplierProductName || '—' }}
          </router-link>
        </dd>

        <dt>Supplier Product Sku</dt>
        <dd>{{ orderItem.supplierProductSku || '—' }}</dd>

        <dt>Supplier Product Price Before Tax</dt>
        <dd>{{ orderItem.supplierProductBeforeTax || '—' }}</dd>

        <dt>Supplier Product  Price After Tax</dt>
        <dd>{{ orderItem.supplierProductAfterTax || '—' }}</dd>

        <dt>Supplier Product Shipping Before Tax</dt>
        <dd>{{ orderItem.supplierProductShippingBeforeTax || '—' }}</dd>

        <dt>Supplier Product Shipping After Tax</dt>
        <dd>{{ orderItem.supplierProductShippingAfterTax || '—' }}</dd>

        <dt>Purchase Quantity</dt>
        <dd>{{ orderItem.quantity || '—' }}</dd>

        <dt>Tracking Code</dt>
        <dd>{{ orderItem.trackingCode || '—' }}</dd>

        <dt>Last Updated</dt>
        <dd>{{ orderItem.updatedAt | dateTime }}</dd>
      </data-list>
    </data-box>
  </main-layout>
</template>

<style lang="scss" module>
  .datalist {
    dt {
      width: 18rem;
    }

    dd {
      width: calc(100% - 18rem);
    }
  }
</style>
